module.exports = __webpack_public_path__ + "static/img/Rtaf_radio_2.417b6ac.png";